import { Expose } from "class-transformer";

export class CreateApiTokenDto {
  @Expose()
  name: string;

  @Expose()
  userId: string;
}
